import { ParsedImgSizes, PixelDensity } from '../types';

export const prepareImgSizes = (sizes: string | string[]): string => {
  let _sizes = '';
  if (Array.isArray(sizes)) _sizes = sizes.join(', ');
  else _sizes = sizes;
  return _sizes;
};

export function parseImgSizes(sizes: string): ParsedImgSizes {
  const sizeRules = sizes.toString().split(',');

  return sizeRules?.map((rule) => {
    const trimmedRule = rule.trim();

    // Split condition and size
    const [condition, size] = trimmedRule.includes(')')
      ? trimmedRule.split(') ').map((str) => str.trim())
      : [null, trimmedRule];

    return { condition, size };
  });
}

export function getPixelDensity(pixelDensity?: PixelDensity): number {
  if (pixelDensity === 'image') return 1.5;
  if (pixelDensity === 'image_with_text') return 2;

  return 1.2;
}

export function getLargestSize(parsedSizes: ParsedImgSizes) {
  const sizeValues = parsedSizes.map((rule) => parseInt(rule.size));
  const largestSize = Math.max(...sizeValues);

  return largestSize;
}

export function addParamsToUrl(
  url: string,
  params: { [key: string]: string | number | undefined },
) {
  let urlObj: URL;
  try {
    urlObj = new URL(url);
    Object.keys(params)
      .filter((key) => params[key] !== undefined)
      .forEach((key) => {
        const value = params[key];
        if (value !== undefined) {
          urlObj.searchParams.set(key, value.toString());
        }
      });
    return urlObj.toString();
  } catch (error) {
    console.warn(`❌addParamsToUrl url: ${url}`, error);
  }
  return url;
}

export function getSrcSet(
  src: string,
  sizes: ParsedImgSizes,
  params: { dpr?: number; quality?: number },
) {

  return sizes
    ?.map(({ size }) => {
      const _params = {
        auto: 'format',
        dpr: params?.dpr,
        q: params?.quality,
        w: size.replace('px', ''),
      };

      return `${addParamsToUrl(src, _params)} ${size.replace('px', '')}w`;
    })
    .join(', ');
}
